import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import config from "../../../config";
import {
  handleAccept,
  handleClose,
  handleEdit,
  handlePause,
  handleReactivate,
  handleReopen,
} from "../../../utils/KnowledgeBase/KnowledgeBaseHandlers";
import { KnowledgeBaseData } from "../../../utils/KnowledgeBase/KnowledgeBaseTypes";
import "../Modal.css";
import ConfirmCloseModal from "./ConfirmClose"; // import the new modal component
import { authFetch } from "../../../utils/Security/authFetch";
import JournalModal from "./JournalModal";
const isAdmin = localStorage.getItem("isAdmin") === "true";

type Message = {
  id: number;
  username: string;
  message: string;
  date: string;
};

type ModalProps = {
  isOpen: boolean;
  data: any;
  onClose: () => void;
};
const hiddenKeys = [
  "isaccepted",
  "isFavorite",
  "isallsite",
  "isclosed",
  "foruserid",
  "isforwarded",
  "isreopened",
  "isreactivated",
];

const ticketInfo = [
  "ticketId",
  "status",
  "createdby",
  "closedby",
  "ticketCreationDatetime",
  "ticketClosureDatetime",
  "ticketcrossrefrencenumber",
];

const customerInfo = [
  "affectedCustomer",
  "affectedNetwork",
  "affectedSite",
  "affectedLink",
  "asset",
];

const statusInfo = [
  "summary",
  "description",
  "solution",
  "closurecode",
  "rootcause",
];

const relInfo = ["filePath", "relatedobject"];

const fieldLabels: { [key: string]: string } = {
  // Ticket Info
  createdby: "Created By",
  user: "User",
  userid: "User",
  ticketId: "Ticket ID",
  status: "Status",
  ticketCreationDatetime: "Ticket Creation Date/Time",
  ticketClosureDatetime: "Ticket Closure Date/Time",
  customerComplaint: "Customer Complaint",
  customerInformed: "Customer Informed",
  ticketcrossrefrencenumber: "Ticket Cross Reference Number",
  closedby: "Closed By",
  // Customer & Network
  affectedCustomer: "Customer",
  affectedNetwork: "Network",
  affectedSite: "Site",
  affectedLink: "Link",
  asset: "Asset",

  // Status & Description
  summary: "Summary",
  description: "Description",
  solution: "Solution",
  closurecode: "Closure Code",
  rootcause: "Root Cause",

  relatedobject: "Related Object",
  // Related
  filePath: "File Attachment",
};
const renderAttachment = (filePaths: string[] | undefined) => {
  if (!filePaths || filePaths.length === 0) return null;

  const handleDownload = async (filePath: string, extension: string) => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      alert("You need to sign in to download this file.");
      return;
    }
    try {
      const url = `https://bdm.bcomsat.com /${filePath.replace(
        /\\/g,
        "/"
      )}`;
      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        alert("Failed to download file. Please sign in.");
        return;
      }

      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = downloadUrl;
      a.download = filePath.split("/").pop() || `file.${extension}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error("Download error:", error);
      alert("Error downloading file.");
    }
  };

  return (
    <>
      {filePaths.map((filePath, index) => {
        const token = localStorage.getItem("authToken");
        const extension = filePath.split(".").pop()?.toLowerCase();

        if (!extension) return null;

        // Construct secure URL pointing to Nginx /files/ endpoint
        const url = `https://bdm.bcomsat.com/api/incidents/files/${encodeURIComponent(
          filePath
        )}?token=${token}`;

        if (["png", "jpg", "jpeg", "gif", "bmp"].includes(extension)) {
          return (
            <img
              key={index}
              src={url}
              alt="attachment"
              style={{
                maxWidth: "100%",
                maxHeight: 300,
                display: "block",
                marginBottom: 10,
              }}
            />
          );
        }

        if (extension === "pdf") {
          return (
            <iframe
              key={index}
              src={url}
              title={`PDF-${index}`}
              style={{
                width: "100%",
                height: "500px",
                border: "none",
                marginBottom: 10,
              }}
            />
          );
        }
        return (
          <button
            key={index}
            onClick={() => handleDownload(filePath, extension)}
            style={{
              display: "block",
              marginBottom: 10,
              backgroundColor: "#007bff",
              color: "white",
              border: "none",
              padding: "6px 12px",
              cursor: "pointer",
              borderRadius: 4,
            }}
          >
            Download attachment ({extension.toUpperCase()})
          </button>
        );
      })}
    </>
  );
};

const Modal: React.FC<ModalProps> = ({ isOpen, data, onClose }) => {
  const navigate = useNavigate();
  console.log("dataaa", data);
  const [selectedKnowledgeBase, setSelectedKnowledgeBase] =
    useState<KnowledgeBaseData | null>(null);
  const [localKnowledgeBaseData, setLocalKnowledgeBaseData] =
    useState<any>(data);

  const [isForwardModalOpen, setIsForwardModalOpen] = useState(false);
  const [journalMessages, setJournalMessages] = useState<Message[]>([]);
  const [showConfirmClose, setShowConfirmClose] = useState(false);
  const [journalTitle, setJournalTitle] = useState("Add Journal");
  const [showJournal, setShowJournal] = useState(false);
  const [pauseAfterJournal, setPauseAfterJournal] = useState(false); // 🟢 new state

  const renderSection = (title: string, keys: string[], data: any) => (
    <div className="modal-section">
      <h3>{title}</h3>
      <div className="modal-section-content">
        {keys
          .filter(
            (key) =>
              data[key] !== undefined &&
              !hiddenKeys.includes(key) &&
              (isAdmin || !["relatedobject"].includes(key))
          )
          .map((key, index) => (
            <div key={index} className="modal-item">
              <strong>{fieldLabels[key] || key}:</strong>
              <div className="modal-value">
                {key === "filePath" ? (
                  renderAttachment(data[key])
                ) : Array.isArray(data[key]) ? (
                  data[key].join(", ")
                ) : typeof data[key] === "string" ? (
                  key === "description" ||
                  key === "summary" ||
                  key === "solution" ? (
                    <div
                      dangerouslySetInnerHTML={{ __html: data[key] }}
                      style={{ whiteSpace: "normal" }}
                    />
                  ) : /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d+)?)?$/.test(
                      data[key]
                    ) ? (
                    new Date(data[key]).toLocaleString()
                  ) : (
                    data[key]
                  )
                ) : (
                  JSON.stringify(data[key], null, 2)
                )}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
  useEffect(() => {
    if (isOpen) {
      //console.log("Dataaaaaaaaaaaaaaaaaa", data);
      setLocalKnowledgeBaseData(data);
      fetchMessages();
    }
  }, [isOpen, data]);

  const closeForwardModal = () => {
    setIsForwardModalOpen(false);
    setSelectedKnowledgeBase(null);
  };

  const fetchMessages = async () => {
    try {
      if (!data?.ticketId) {
        console.warn("No ticket ID found in data.");
        return;
      }

      const response = await authFetch(
        `${config.apiBaseUrl}/api/messages/ticket/${data.ticketId}`
      );

      if (response.ok) {
        const messages: Message[] = await response.json();
        setJournalMessages(messages);
      } else {
        console.error("Failed to fetch messages");
      }
    } catch (error) {
      console.error("Error while fetching messages:", error);
    }
  };

  if (!isOpen) return null;

  const handleForward = (data: KnowledgeBaseData) => {
    setSelectedKnowledgeBase(data);
    setIsForwardModalOpen(true);
  };

  const isAccepted = data?.isaccepted;
  const isClosed = data?.isclosed;
  const isPaused = data?.ispaused;

  const confirmClose = () => {
    handleClose(data, fetchMessages);
    setShowConfirmClose(false);
    onClose(); // Close the main modal as well
  };
  const handleJournalConfirm = async () => {
    setShowJournal(false);
    onClose();
  };
  return (
    <>
      {showConfirmClose && (
        <ConfirmCloseModal
          data={data}
          onConfirm={confirmClose}
          onCancel={() => setShowConfirmClose(false)}
        />
      )}
      {showJournal && (
        <JournalModal
          title={journalTitle}
          data={data}
          onConfirm={handleJournalConfirm}
          onCancel={() => {
            setPauseAfterJournal(false);
            setShowJournal(false);
          }}
        />
      )}
      <div className="modal-overlay">
        <div className="modal-content">
          <div
            className="modal-top-buttons"
            style={{
              position: "sticky",
              top: -32,
              backgroundColor: "#fff",
              zIndex: 100,
              padding: "10px",
              display: "flex",
              flexWrap: "wrap",
              gap: "10px",
            }}
          >
            <button onClick={() => handleEdit(data, navigate, fetchMessages)}>
              Edit
            </button>
            <button onClick={() => handleClose(data, fetchMessages)}>
              Close
            </button>{" "}
            {isClosed && (
              <button onClick={() => handleReopen(data, fetchMessages)}>
                Reopen
              </button>
            )}
            <button onClick={onClose}>X</button>
          </div>

          <h2
            style={{
              position: "sticky",
              top: 16, // slightly below the buttons
              backgroundColor: "#fff",
              zIndex: 99,
              margin: 0,
              padding: "10px 0",
            }}
          >
            Knowledge Base Details
          </h2>
          <div className="modal-body">
            {renderSection("Knowledge Base Information", ticketInfo, data)}
            {renderSection("Customer & Network", customerInfo, data)}
            {renderSection("Knowledge Base Details", statusInfo, data)}
            {renderSection("Related Object", relInfo, data)}
          </div>

          <div className="messages-container">
            {isAdmin && (
              <div className="journal">
                <button
                  onClick={() => {
                    setJournalTitle("Add Journal");
                    setShowJournal(true);
                  }}
                >
                  Add Journal
                </button>
                <h3>Journal</h3>
                <ul>
                  {[...journalMessages]
                    .sort(
                      (a, b) =>
                        new Date(b.date).getTime() - new Date(a.date).getTime()
                    )
                    .map((msg) => (
                      <li key={msg.id}>
                        <strong>{msg.username}</strong>:&nbsp;
                        <span
                          dangerouslySetInnerHTML={{ __html: msg.message }}
                          style={{ display: "inline-block", maxWidth: "100%" }}
                        />
                        <br />
                        <small>{new Date(msg.date).toLocaleString()}</small>
                      </li>
                    ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Modal;
